export default {
	INGREDIENT_VARIATIONS: 'Ingredient Variations',
	INGREDIENT_VARIATIONS_OPTIONS: 'Ingredient Variations Options'
};